import { getRedirectUrl, clearRedirectUrl } from '@/utils/redirect'

function isForceHttpOnlyMode(): boolean {
  return import.meta.env.VITE_FORCE_HTTPONLY_MODE === 'true'
}

function resolvePayFullUrl(pathOrUrl: string, appBaseUrl: string): string {
  if (pathOrUrl.startsWith('/')) {
    return `${appBaseUrl}${pathOrUrl}`
  }
  if (!pathOrUrl.startsWith('http')) {
    return `${appBaseUrl}/${pathOrUrl}`
  }
  return pathOrUrl
}

export function buildPayPostAuthUrl(
  pathOrUrl: string,
  appBaseUrl: string,
  email: string,
  token: string,
  forceHttpOnlyMode: boolean,
): string {
  const fullUrl = resolvePayFullUrl(pathOrUrl, appBaseUrl)
  const url = new URL(fullUrl)
  const isLocalDev = url.hostname === 'localhost' || url.hostname === '127.0.0.1'

  url.searchParams.set('auth_email', email)
  url.searchParams.set('auth_from', 'ecx-auth')

  const useHttpOnly = !isLocalDev || forceHttpOnlyMode
  if (useHttpOnly) {
    url.searchParams.set('auth_mode', 'httponly')
  } else {
    url.searchParams.set('auth_token', token)
    url.searchParams.set('auth_mode', 'token')
  }

  return url.toString()
}

export function redirectPayAfterAuth(appBaseUrl: string, email: string, token: string): void {
  const forceHttpOnly = isForceHttpOnlyMode()
  const savedRedirectUrl = getRedirectUrl()

  if (savedRedirectUrl) {
    clearRedirectUrl()
    window.location.href = buildPayPostAuthUrl(savedRedirectUrl, appBaseUrl, email, token, forceHttpOnly)
    return
  }

  window.location.href = buildPayPostAuthUrl(appBaseUrl, appBaseUrl, email, token, forceHttpOnly)
}

export function redirectCorpAfterAuth(corpBaseUrl: string): void {
  const savedRedirectUrl = getRedirectUrl()
  clearRedirectUrl()

  let targetUrl: string
  if (savedRedirectUrl) {
    if (savedRedirectUrl.startsWith('/')) {
      targetUrl = `${corpBaseUrl}${savedRedirectUrl}`
    } else if (savedRedirectUrl.startsWith('http')) {
      targetUrl = savedRedirectUrl
    } else {
      targetUrl = `${corpBaseUrl}/${savedRedirectUrl}`
    }
  } else {
    targetUrl = corpBaseUrl
  }

  window.location.href = targetUrl
}
